<script setup>
import { useScrollStore } from "@/stores/scroll";

const scroll = useScrollStore();

defineProps({
  campaign: {
    type: Object,
    required: true
  },
  isMember: {
    type: Boolean,
    required: false,
    default: false
  }
});
</script>

<template>
  <div
    class="fixed inset-x-0 z-50 mx-auto max-w-campaign transform shadow-sm transition-all duration-300 isp-top-0"
    :class="[scroll.getScrollTop > 120 ? 'translate-y-0 opacity-100' : 'pointer-events-none -translate-y-full opacity-0']"
  >
    <div class="mx-auto flex h-14 max-w-campaign items-center bg-campaign text-campaign">
      <div class="flex min-w-0 flex-1 items-center space-x-3 pl-4">
        <img
          class="h-9 w-9 flex-shrink-0 overflow-hidden rounded-full object-cover shadow-sm"
          :src="campaign.profile_photo_url"
          alt="profile photo"
        />
        <h1 class="truncate text-base font-bold tracking-tight">
          {{ campaign.title }}
        </h1>
      </div>
    </div>
  </div>
</template>
